import _ from 'lodash'

import Vue from 'vue'
import api from './index'
import store from '../store'

export default {
  config () {
    return {
      apiURL: Vue.config.app.API_URL,
      headers: {
        'Authorization': 'Token ' + store.getters.token
      }
    }
  },
  request (config, endpoint, params, headers = {}) {
    config.url = `${this.config().apiURL}${endpoint}/`
    config.params = params
    config.headers = Object.assign(api.config().headers, this.config().headers)
    config.headers = Object.assign(config.headers, headers)
    return api.request(config).then(response => {
      return response.data
    }).catch(error => {
      if (!error.response) {
        store.commit('error', 'Se perdió la conexión con el servidor.')
      } else if (_.includes([500, 404], error.response.status)) {
        store.commit('error', 'Error inesperado.')
      } else if (_.includes([401], error.response.status)) {
        store.dispatch('logOut')
      } else if (_.includes([403], error.response.status)) {
        store.commit('error', 'Acceso denegado.')
        store.commit('toRoute', 'home')
      } else {
        throw error
      }
    })
  },
  getURL (url) {
    let config = {
      method: 'get',
      url: url,
      headers: Object.assign(api.config().headers, this.config().headers)
    }
    return api.request(config).then(response => {
      return response.data
    })
  },

  login (user, password) {
    let config = {
      method: 'post',
      url: `${this.config().apiURL}token/`,
      data: { 'username': user, 'password': password }
    }

    return api.request(config)
  },

  // Incidents
  createIncident (data) {
    return this.request({ method: 'post', data: data }, `incidents`)
  },
  getIncidents (params) {
    return this.request({ method: 'get' }, 'incidents', params)
  },
  getIncident (id) {
    return this.request({ method: 'get' }, `incidents/${id}`)
  },
  editIncident (id, data) {
    let headers = {}

    if ('attachment' in data) {
      headers = {'Content-Type': 'multipart/form-data'}
    }

    return this.request({method: 'patch', data: data}, `incidents/${id}`, null, headers)
  },
  getIncidentStatuses () {
    return this.request({ method: 'get' }, 'incident-statuses')
  },

  // Processes
  createProcess (data) {
    return this.request({ method: 'post', data: data }, 'processes')
  },
  getProcesses (params) {
    return this.request({ method: 'get' }, 'processes', params)
  },
  getProcess (id) {
    return this.request({ method: 'get' }, `processes/${id}`)
  },
  editProcess (id, data) {
    return this.request({ method: 'patch', data: data }, `processes/${id}`)
  },
  getProcessStatuses () {
    return this.request({ method: 'get' }, 'process-statuses')
  },

  // Weighings
  editWeighing (id, data) {
    return this.request({ method: 'patch', data: data }, `weighings/${id}`)
  },

  // Measurements
  getMeasurements (params) {
    return this.request({ method: 'get' }, 'measurements', params)
  },
  getMeasurement (id) {
    return this.request({ method: 'get' }, `measurements/${id}`)
  },
  editMeasurement (id, data) {
    return this.request({ method: 'patch', data: data }, `measurements/${id}`)
  },

  // Masters
  getRawMaterials () {
    let queryParams = {is_raw_material: true}
    return this.request({ method: 'get' }, 'materials', queryParams)
  },
  getProcessTypeRawMaterials (processTypeId) {
    let queryParams = {process_type: processTypeId}
    return this.request({ method: 'get' }, 'materials', queryParams)
  },
  getProcessTypes () {
    return this.request({ method: 'get' }, 'process-types')
  },
  getTags () {
    return this.request({ method: 'get' }, 'tags')
  },
  getMachines () {
    return this.request({ method: 'get' }, 'machines')
  },
  getSeverities () {
    return this.request({ method: 'get' }, 'severities')
  },
  getDevices () {
    return this.request({ method: 'get' }, 'devices')
  },
  getDevice (id) {
    return this.request({ method: 'get' }, `devices/${id}`)
  },
  report (name, data) {
    return this.request({ method: 'post', data: data }, 'reports', { report_name: name })
  },

  // Devices
  startDevice (id, data) {
    return this.request({ method: 'post', data }, `devices/${id}/start`)
  },
  stopDevice (id) {
    return this.request({ method: 'post' }, `devices/${id}/stop`)
  },
  zeroDevice (id) {
    return this.request({ method: 'post' }, `devices/${id}/zero`)
  },
  getDeviceInfo (id) {
    return this.request({ method: 'get' }, `devices/${id}/info`)
  }
}



// WEBPACK FOOTER //
// ./src/api/app.js